// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"902827f7","257":"798ad676","573":"fcc96e4a","646":"eed57ec7","649":"426ce0fd","787":"8d110c98","870":"c9fb3054"}[chunkId] + ".chunk.js";
};